import {UmpireCompetition} from '../umpire-competition';
import {UmpireCompetitionSeason} from '../umpire-competition-season';
import {UmpireExternalProviderPointer} from '../umpire-external-provider-pointer';

export interface UmpireSeason {
  type: 'season';

  id: string;

  name: string;

  is_current: boolean;

  competitions: UmpireCompetition[];

  competition_seasons: UmpireCompetitionSeason[];

  slug: string | null;

  external_provider_pointers: UmpireExternalProviderPointer[];

  publication_time: string | null;

  published_at: string | null;
}
